
import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling, stackStyling, descriptionStyling, dropDownFormStyle } from 'components/forms/new/formStyles';
import { Field } from 'formik';

const options = [
    { label: 'Fixed', value: 0 },
    { label: 'User', value: 1 },
    { label: 'Channel', value: 2 },
    { label: 'Number', value: 3 },
];



const CallInclusionTypeField = ({ darkMode}) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <Field name="inclusionType" validate={value => (value === null || value === undefined || value === '') ? 'Please select an inclusion type.' : undefined}>
            {({ form, meta }) => {
                const error = meta.error;
                const showError = meta.touched;
                let errorMsg = undefined;
                if (showError) {
                    if (form.values.inclusionType === null || form.values.inclusionType === undefined || form.values.inclusionType === '') {
                        errorMsg = 'Please select an inclusion type.';
                    } else if (error) {
                        errorMsg = error;
                    }
                }
                return (
                    <FormControl
                        sx={{ margin: '0 0 24px 0 !important', width: '100%' }}
                        isInvalid={!!errorMsg}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <Stack direction="row" alignItems="flex-start" sx={stackStyling(true)} >
                            <Box>
                                <FormLabel sx={formLabelStyling(darkMode)} color={darkMode ? 'white' : 'black'}>
                                    Included Minutes Per <span style={{ color: '#e53e3e' }}>*</span>
                                </FormLabel>
                                <Text sx={descriptionStyling} fontSize="sm" color={darkMode ? 'gray.300' : 'gray.600'} maxWidth={250}>
                                    Specify the period for included minutes.
                                </Text>
                            </Box>
                            <Box flex="1" minWidth="450px">
                                <Box
                                    sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '20px', marginRight: '6px'  }}>
                                    <VStack width="100%" alignItems="normal">
                                        <Select
                                            placeholder="- Select Inclusion Type -"
                                            value={options.find(opt => opt.value === form.values.inclusionType) || null}
                                            onChange={e => form.setFieldValue('inclusionType', e.value)}
                                            options={options}
                                            chakraStyles={dropDownFormStyle(darkMode)}
                                            menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            onBlur={() => form.setFieldTouched('inclusionType', true)}
                                        />
                                        {!!errorMsg && (
                                            <Text color="red.500" fontSize="xs" mt={1} textAlign="right">
                                                {errorMsg}
                                            </Text>
                                        )}
                                    </VStack>
                                </Box>
                            </Box>
                            {isHovered && (
                                <FieldToolTip
                                    label="Specify the period for included minutes."
                                    ariaLabel="call-inclusion-type-tip"
                                    left="25px"
                                    top="25px"
                                />
                            )}
                        </Stack>
                    </FormControl>
                );
            }}
        </Field>
    );
};

export default CallInclusionTypeField;
